module.exports = __webpack_public_path__ + "static/img/2.500cd4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/yinyuedeng/2.jpg
// module id = 6GvN
// module chunks = 1